/**
 * Configuration for the app.
 */
const jobiqoAppConfig = require('./../../src/jobiqo/config/app');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

const defaultLocale = 'en';
const defaultRegion = 'eu';
const locales = ['en'];
const priceConfig = {
  CURRENCY_PLACEMENT: 'before',
  USE_SPACING: false,
};
module.exports = mergeDeepRight(jobiqoAppConfig, {
  public: {
    TURBOPACK_BUILD: true,
    EURO_VAT_SYSTEM: false,
    SITENAME: 'Monterey County Weekly Jobs',
    SITE_DESCRIPTION:
      'Get career and job search advice, or search over 2 million jobs on the largest job network',
    DEFAULT_LOCALE: defaultLocale,
    DEFAULT_REGION: defaultRegion,
    LOCALES: locales,
    PRICE_CONFIG: priceConfig,
    SOCIAL_LINKS: {
      facebook: 'https://www.facebook.com/MontereyCountyWeekly',
      twitter: 'https://twitter.com/mcweekly',
      youtube: 'https://www.youtube.com/user/montereycountyweekly',
    },
    ASSETS: {
      logo: '/static/montereycountyweekly/logo.svg',
      faviconsPath: '/static/montereycountyweekly',
    },
    OG_IMAGE: '/static/montereycountyweekly/logo.svg',
    AUTOCOMPLETE_WIDGET_OPTIONS: {
      country: ['us', 'ca'],
    },
    THEME: {
      colors: {
        primary: '#000000',
        secondary: '#cc0000',
      },
      logo: {
        minHeight: 100,
      },
    },
    LINKEDIN_OAUTH_FEATURE_ACTIVE: false,
    FACEBOOK_OAUTH_FEATURE_ACTIVE: false,
    GOOGLE_OAUTH_FEATURE_ACTIVE: false,
    GA4_MEASUREMENT_IDS: ['G-87DB4XHF7W'],
    BLOG_FEATURE_ACTIVE: true,
  },
});
